<template>
  <div class="groupsList">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header @back="goBack" :content="$t('lang.title_groupsList')"></el-page-header>
    </div>
    <!-- 自动分组 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 赛事项目 -->
        <el-form-item :label="$t('lang.lab_competeItem')">
          <span class="color-opacity80">{{ this.competeItemName }}</span>
        </el-form-item>
        <!-- 自动分组 -->
        <el-form-item :label="$t('lang.lab_autoGroup')"></el-form-item>
        <!-- 每组比赛人数select -->
        <el-form-item :label="$t('lang.lab_groupNum')">
          <el-select v-model="autoGroup" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_groupNum')" @change="changeAutoGroup">
            <el-option
              v-for="(item,index) in autoGroups"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 分组数 -->
        <el-form-item :label="$t('lang.lab_groupCount')">
          <span>{{ this.autoGroupCount|valueIsNull }}</span>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <!-- 筛选 -->
      <el-form :inline="true" label-suffix=":">
        <!-- 姓名input -->
        <el-form-item :label="$t('lang.lab_name')">
          <input style="display: none"/>
          <el-input v-model="name" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_name')"></el-input>
        </el-form-item>
        <!-- 性别select -->
        <el-form-item :label="$t('lang.lab_gender')">
          <el-select v-model="gender" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_gender')">
            <el-option
              v-for="(item,index) in genders"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 代表队select -->
        <el-form-item :label="$t('lang.lab_delegation')">
          <el-select v-model="delegationId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_delegation')">
            <el-option
              v-for="(item,index) in delegations"
              :key="index"
              :value="item.id"
              :label="item.teamName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 证件号input -->
        <el-form-item :label="$t('lang.lab_certificateNum')">
          <input style="display: none"/>
          <el-input v-model="certificateNum" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_certificateNum')"></el-input>
        </el-form-item>
        <!-- 分组select -->
        <el-form-item :label="$t('lang.lab_group')">
          <el-select v-model="group" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_group')">
            <el-option key :label="$t('lang.pla_pleaseSelect')+$t('lang.lab_group')" value=''></el-option>
            <el-option
              v-for="(item,index) in groups"
              :key="index"
              :value="item"
              :label="item">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 数据 导入导出 -->
      <el-upload
        ref="uploading"
        slot="header"
        action
        :on-remove="handleRemove"
        :on-change="handleSuccess"
        :on-exceed="outlimit"
        :on-error="uploadErr"
        :limit="1"
        accept=".xlsx"
        :file-list="fileList"
        :auto-upload="false">
        <el-button slot="trigger" size="primary" type="primary">{{$t('lang.btn_selectExcel')}}</el-button>
        <el-button style="margin-right: 10px;" size="primary" type="success" @click="onImport">{{$t('lang.btn_importData')}}</el-button>
        <el-button style="margin-left: 10px;" size="primary" type="primary" @click="onExport">{{$t('lang.btn_exportData')}}</el-button>
      </el-upload>
      
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @sort-change="changeTableSort"
      >
        <!-- 姓名 -->
        <el-table-column prop="name" :label="$t('lang.lab_name')" :sortable="'custom'"></el-table-column>
        <!-- 代表队 -->
        <el-table-column prop="teamName" :label="$t('lang.lab_delegation')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.teamName | valueIsNull}}</span>
          </template>          
        </el-table-column>
        <!-- 证件类型 -->
        <el-table-column prop="idType" :label="$t('lang.lab_certificateType')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{scope.row.idType.replace(new RegExp('0','g'),$t('lang.MeetingRecordDetail_idType[0].name')).replace(new RegExp('1','g'),$t('lang.MeetingRecordDetail_idType[1].name')).replace(new RegExp('2','g'),$t('lang.MeetingRecordDetail_idType[2].name')).replace(new RegExp('3','g'),$t('lang.MeetingRecordDetail_idType[3].name'))}}</span>
            <!-- 0: 身份证 -->
            <!-- <span v-if="scope.row.idType === '0'">{{$t('lang.MeetingRecordDetail_idType[0].name')}}</span> -->
            <!-- 1: 护照 -->
            <!-- <span v-if="scope.row.idType === '1'">{{$t('lang.MeetingRecordDetail_idType[1].name')}}</span> -->
            <!-- 2: 港澳身份证 -->
            <!-- <span v-if="scope.row.idType === '2'">{{$t('lang.MeetingRecordDetail_idType[2].name')}}</span> -->
            <!-- 3: 台胞证 -->
            <!-- <span v-if="scope.row.idType === '3'">{{$t('lang.MeetingRecordDetail_idType[3].name')}}</span> -->
          </template>
        </el-table-column>
        <!-- 证件号 -->
        <el-table-column prop="idCard" :label="$t('lang.lab_certificateNum')" :sortable="'custom'"></el-table-column>
        <!-- 历史最好成绩 -->
        <el-table-column prop="bestResult" :label="$t('lang.lab_historyBestRecord')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.bestResult | valueIsNull}}</span>
          </template>
        </el-table-column>
        <!-- 分组 -->
        <el-table-column prop="groupNum" :label="$t('lang.lab_group')" :sortable="'custom'">
          <template slot-scope="scope">
            <el-select v-model="scope.row.groupNum" @change="changeGroup(scope.row.id,scope.row.groupNum,scope.row.swimLane)">
              <el-option key label='-' value='-'></el-option>
              <el-option
                v-for="(item,index) in groups"
                :key="index"
                :value="item"
                :label="item">
              </el-option>
            </el-select> 
          </template>
        </el-table-column>
        <!-- 泳道 -->
        <el-table-column prop="swimLane" :label="$t('lang.lab_swimLane')" :sortable="'custom'">
          <template slot-scope="scope">
            <el-select v-model="scope.row.swimLane" @change="changeLane(scope.row.id,scope.row.groupNum,scope.row.swimLane)">
              <el-option key label='-' value='-'></el-option>
              <el-option
                v-for="(item,index) in swimLanes"
                :key="index"
                :value="item"
                :label="item">
              </el-option>
            </el-select> 
          </template>          
        </el-table-column>
        <!-- 成绩 -->
        <el-table-column prop="result" :label="$t('lang.lab_record')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.result | valueIsNull}}</span>
          </template>          
        </el-table-column>
        <!-- 分组名次 -->
        <el-table-column prop="groupRanking" :label="$t('lang.lab_groupRanking')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.groupRanking | valueIsNull}}</span>
          </template>   
        </el-table-column>
        <!-- 总名次 -->
        <el-table-column prop="totalRanking" :label="$t('lang.lab_totalRanking')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.totalRanking | valueIsNull}}</span>
          </template>   
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button v-if="scope.row.remark" @click="onRemark(scope.row.remark)">{{$t('lang.btn_notes')}}</el-button>
            <el-button @click="onDetail(scope.row.idCard)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 备注 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="880px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form ref="form" label-width="100px" label-suffix=":">
        <!-- 备注 -->
        <el-form-item :label="$t('lang.btn_notes')">
          <span>{{ this.form.remark}}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:groupsList
 *@Description:选手分组管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-16
 */
import { excelDownload } from '../../config/download.js'

export default {
  name: '',
  components: {},
  data() {
    return {
      competeItemId: '', // 通过赛事项目id查看选手分组
      competeItemName: '', // 赛事项目名称
      isShow: false, // 备注dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_notes'), // 备注dialog的title
      /* 选手分组管理列表变量 */
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      autoGroups: this.$i18n.t('lang.Groups_autogGroups'), // 自动分组下拉list
      genders: this.$i18n.t('lang.Players_gender'), // 性别下拉list
      delegations: [], // 代表队下拉list
      groups: [], // 分组下拉list
      swimLanes: [], // 泳道下拉list
      autoGroup: '', // 自动分组-每组比赛人数
      autoGroupCount: '', // 自动分组-分组数
      name: '', // 筛选-姓名
      gender: '', // 筛选-性别
      delegationId: '', // 筛选-代表队
      certificateNum: '', // 筛选-证件号
      group: '', // 筛选-分组
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 选手分组管理列表数据
      /* 记忆筛选项值 */
      name_bak: '', // 备份-姓名
      gender_bak: '', // 备份-性别
      delegationId_bak: '', // 备份-代表队
      certificateNum_bak: '', // 备份-证件号
      group_bak: '', // 备份-分组
      /* 数据导出 */
      allData: [], 
      /* 成绩导入 */
      uploadFile: '', // 文件
      fileList: [], // 上传
      /* 选手分组管理(备注)变量 */
      form: {
        remark: ''
      }, // 详细数据
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 获取选手分组管理列表数据
    getData() { 
      let params = {
        competeItemId: this.competeItemId,
        pageNum: this.pageNum,
        pageSize: this.pageSize       
      }
      this.$postJson('/player/offLine/getPlayerGroup', params).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取赛事项目信息
    getInfoData() { 
      this.$get(`/player/offLine/getGroupInfo?competeItemId=${this.competeItemId}`).then(
        res => {
          if (res && res.code === 200) {
            // 分组下拉list
            this.groups = res.data.groupList
            // 泳道下拉list
            this.swimLanes = res.data.swimLaneList
            // 组别数
            this.autoGroupCount = res.data.groupNumber
            // 每组比赛人数 
            this.autoGroup = res.data.groupPersonNum
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取代表队下拉list
    getDelegationList() {
      this.$get(`/compete/team?competeId=${this.competeId}`).then(
        res => {
          if (res && res.code === 200) {
            this.delegations = res.data
            let newValue = {
              id: '',
              teamName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_delegation')
            }
            this.delegations.unshift(newValue)  
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.name_bak = this.name
        this.gender_bak = this.gender
        this.delegationId_bak = this.delegationId
        this.certificateNum_bak = this.certificateNum
        this.group_bak = this.group
      } else { 
        // 筛选项正确显示
        this.name = this.name_bak
        this.gender = this.gender_bak
        this.delegationId = this.delegationId_bak
        this.certificateNum = this.certificateNum_bak
        this.group = this.group_bak
      }
      let params = {
        competeItemId: this.competeItemId,
        name: this.name,
        gender: this.gender,
        teamId: this.delegationId,
        idCard: this.certificateNum,
        group: this.group,
        sortName: this.sortName,
        sortFieldName: this.sortFieldName,
        pageNum: this.pageNum,
        pageSize: this.pageSize    
      }
      this.$postJson('/player/offLine/getPlayerGroup', params).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.name = ''
      this.gender = ''
      this.delegationId = ''
      this.certificateNum = ''
      this.group = ''
      this.name_bak = ''
      this.gender_bak = ''
      this.delegationId_bak = ''
      this.certificateNum_bak = ''
      this.group_bak = ''
      this.sortName = ''
      this.sortFieldName = ''
      this.pageNum = 1
      this.getData()
      this.getInfoData()
    },    
    // 查看
    onDetail(id) {
      console.log('onDetail', id)
      this.$router.push({ name: 'playerInfo', query: { idCard: id, source: 1 } })
    },
    // 备注
    onRemark(data) {
      console.log('onRemark', data)
      this.form.remark = data
      this.isShow = true
    },
    // 每组比赛人数
    changeAutoGroup() {
      console.log('每组比赛人数')
      let params = {
        itemId: this.competeItemId,
        groupPersonNum: this.autoGroup,        
      }
      this.$postJson('/player/grouping', params).then(
        res => {
          if (res && res.code === 200) {
            // 分组数
            this.autoGroupCount = res.data.groupNum
            // 更新列表
            this.onClear()
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )  
    },
    // 手动换分组
    changeGroup(id, group, swimLane) {
      let params = {
        id: id,
        group: group,
        swimLane: swimLane,
      }
      this.$postJson('/player/adjust', params).then(
        res => {
          if (res && res.code === 200) {
            this.onSearch(false, false)
          } else {
            this.$message.error(res.message)
            this.onSearch(false, false)
          }
        },
        error => {
          this.$message.error(error)
        }
      )    
    },
    // 手动换泳道
    changeLane(id, group, swimLane) {
      let params = {
        id: id,
        group: group,
        swimLane: swimLane,
      }
      this.$postJson('/player/adjust', params).then(
        res => {
          if (res && res.code === 200) {
            this.onSearch(false, false)
          } else {        
            this.$message.error(res.message)
            this.onSearch(false, false)
          }
        },
        error => {
          this.$message.error(error)
        }
      )    
    },
    // 监听关闭'备注'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.form.remark = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
    // 获取全部数据
    getAllData() {
      // 筛选项正确显示
      this.name = this.name_bak
      this.gender = this.gender_bak
      this.delegationId = this.delegationId_bak
      this.certificateNum = this.certificateNum_bak
      this.group = this.group_bak
      let params = {
        competeItemId: this.competeItemId,
        name: this.name,
        gender: this.gender,
        teamId: this.delegationId,
        idCard: this.certificateNum,
        group: this.group,
        sortName: this.sortName,
        sortFieldName: this.sortFieldName,   
      }
      this.$postJson('/player/offLine/getPlayerGroup', params).then(
        res => {
          if (res && res.code === 200) {
            // 选手分组管理列表
            this.allData = res.data.list
            let newArr = []
            let type = ''
            if (this.allData.length > 0) {
              for (let i = 0; i < this.allData.length; i++) {
                // 如果不包含, 就是个人导出，按照原代码逻辑判断
                if (this.allData[i].idType.indexOf(',') == -1) {
                  // 判断证件类型
                  if (this.allData[i].idType === '0') {
                    type = this.$i18n.t('lang.MeetingRecordDetail_idType[0].name')
                  } else if (this.allData[i].idType === '1') {
                    type = this.$i18n.t('lang.MeetingRecordDetail_idType[1].name')
                  } else if (this.allData[i].idType === '2') {
                    type = this.$i18n.t('lang.MeetingRecordDetail_idType[2].name')
                  } else if (this.allData[i].idType === '3') {
                    type = this.$i18n.t('lang.MeetingRecordDetail_idType[3].name')
                  }
                } else {
                  let arr = this.allData[i].idType.split(',')
                  for (let m = 0; m < arr.length; m++) {
                    if (arr[m] === '0') {
                      arr[m] = this.$i18n.t('lang.MeetingRecordDetail_idType[0].name')
                    } else if (arr[m] === '1') {
                      arr[m] = this.$i18n.t('lang.MeetingRecordDetail_idType[1].name')
                    } else if (arr[m] === '2') {
                      arr[m] = this.$i18n.t('lang.MeetingRecordDetail_idType[2].name')
                    } else if (arr[m] === '3') {
                      arr[m] = this.$i18n.t('lang.MeetingRecordDetail_idType[3].name')
                    }
                  }
                  type = arr.join()
                }
                newArr.push({
                  name: this.allData[i].name,
                  teamName: this.allData[i].teamName,
                  idType: type,
                  idCard: this.allData[i].idCard,
                  exportBestResult: this.allData[i].exportBestResult,
                  groupNum: this.allData[i].groupNum,
                  swimLane: this.allData[i].swimLane,
                  exportResult: this.allData[i].exportResult,
                  groupRanking: this.allData[i].groupRanking,
                  totalRanking: this.allData[i].totalRanking,
                  remark: this.allData[i].remark,
                })
              }
            }
            // Excel表头
            const tHeader = [
              this.$i18n.t('lang.lab_name'),
              this.$i18n.t('lang.lab_delegation'),
              this.$i18n.t('lang.lab_certificateType'),
              this.$i18n.t('lang.lab_certificateNum'),
              this.$i18n.t('lang.lab_historyBestRecord'),
              this.$i18n.t('lang.lab_group'),
              this.$i18n.t('lang.lab_swimLane'),
              this.$i18n.t('lang.lab_record') + this.$i18n.t('lang.lab_resultRule'),
              this.$i18n.t('lang.lab_groupRanking'),
              this.$i18n.t('lang.lab_totalRanking'),
              this.$i18n.t('lang.btn_notes'),
            ]
            // 对应table数据的列字段名
            const filterVal = [
              'name',
              'teamName',
              'idType',
              'idCard',
              'exportBestResult',
              'groupNum',
              'swimLane',
              'exportResult',
              'groupRanking',
              'totalRanking',
              'remark',
            ]
            excelDownload(tHeader, filterVal, newArr, this.competeItemName)
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 数据导出
    onExport() {
      if (navigator.onLine) {
        this.$confirm(this.$i18n.t('lang.lab_notModify1') + this.$i18n.t('lang.lab_record') + this.$i18n.t('lang.lab_notModify2'), this.$i18n.t('lang.lab_prompt'),
          {
            confirmButtonText: this.$i18n.t('lang.btn_startExport'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            showCancelButton: false,
            type: 'info'
          }
        ).then(() => {
          this.getAllData()        
        })
        .catch(() => {
        })
      } else {
        this.$message.error(this.$i18n.t('lang.warning_network'))
      }      
    },
    // 文件上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.warning_uploadLimit'))
    },
    // 文件移除
    handleRemove(file, fileList) {
      console.log('Remove Success!', file, fileList)
      this.fileList = []
      this.uploadFile.length = 0
    },
    // 文件上传
    handleSuccess(e) {
      console.log('Upload Success!', e)
      this.uploadFile = e.raw
    },
    // 上传文件的断网
    uploadErr() {
      if (!navigator.onLine || window.navigator.onLine === false) {
        const loading = this.$loading()
        setTimeout(() => {
          loading.close()
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }, 500)
      }
    },
    // 成绩导入
    onImport() {
      if (this.uploadFile.length < 1) {
        this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcDoc'))
      } else {
        let formData = new FormData()
        formData.append('competeItemId', this.competeItemId)
        formData.append('files', this.uploadFile)
        let loading = this.$loading()
        this.$postFormData(`/player/offLine/importResult/`, formData).then(
          res => {
            loading.close()
            if (res && res.code === 200) {
              this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
              this.onClear()
              this.fileList = []
            } else {
              this.$confirm(res.message, this.$i18n.t('lang.lab_prompt'),
                {
                  confirmButtonText: this.$i18n.t('lang.btn_confirm'),
                  cancelButtonText: this.$i18n.t('lang.btn_cancel'),
                  showCancelButton: false,
                  type: 'warning'
                }
              ).then(() => {           
                })
                .catch(() => {
                })  
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    this.competeItemId = this.$route.query.competeItemId
    this.competeId = this.$route.query.competeId
    this.competeItemName = this.$route.query.competeItemName
    if (this.competeItemId !== '') {
      this.getInfoData()
      this.getDelegationList()
      this.getData()
    }
  },
  mounted() {}
}
</script>

<style lang='scss'>
.groupsList{
 .color-opacity80{
   color: #636363;
 }
}
</style>
